export default __webpack_public_path__ + "static/media/ricevuta_acquisto_smartphonecash_-06.4bc31bd4.svg";